import React from 'react';
import Axios from 'axios';
import AutoSuggestPlayer from '../../shared/AutoSuggest/AutoSuggestPlayer';
import moment from 'moment';

const cstTableHeaders = [
	'Ligue', 'Saison', 'Inscriptions', 'Paiements', 'Bourses', 'Versements', 'Transferts', 'Solde Ligue', ''];

const cstDefaultSortOrder = [
	'asc', 'asc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', ''];

const cstDefaultSortFieldIdx = 0;
const cstAccountTransferBtnIdx = 8;

const cstDetaultTotal = {
	inscription: 0, paiement: 0, bourse:0, versement: 0, transfert: 0, balance: 0, playerAccount: 0, playerBalance: 0
};


class QvneaBooksPlayerAccount extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			playerId: '0',
			player: {},
			dataTable: [],
			sortFieldIdx: cstDefaultSortFieldIdx,
			sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],
			seasonsTotal: cstDetaultTotal,
		};

    this.handlePlayerChange = this.handlePlayerChange.bind(this);
		this.createDataTable = this.createDataTable.bind(this);
		this.sortdataTable = this.sortdataTable.bind(this);
		this.createTableHdrRow = this.createTableHdrRow.bind(this);
		this.createDataRow = this.createDataRow.bind(this);
		this.createDataCell = this.createDataCell.bind(this);
		this.handleSetAccountBalanceClick = this.handleSetAccountBalanceClick.bind(this);
	}

 	componentDidMount() {
		this.loadSeasonsBalance(this.state.playerId);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		//console.log(nextProps);
		// this.loadSeasonsBalance(this.state.playerId);
	}

  loadSeasonsBalance(playerId) {
    var _this = this;
		if (localStorage.getItem('filtPlayerId') !== null) {
			playerId = localStorage.getItem('filtPlayerId');
		}

		if (playerId !== '0') {
	    Axios.get('/api/qvneaBooks/playerAccount/' + playerId).then(function (response) {
	    	_this.createDataTable(playerId, response.data);
			});
		}
  }

	createDataTable(playerId, dataResults) {
		var _this = this;
		var dataTable = [];

		var seasonsTotal = dataResults.qvneaBooksTotal;

		this.setState({
			player: dataResults.player,
			seasonsTotal: seasonsTotal,
		});

		this.buildOneDataTable(dataTable, dataResults.seasons, seasonsTotal.playerAccount, function() {
			_this.sortdataTable(dataTable, _this.state.sortFieldIdx, _this.state.sortOrder, playerId);
		});
	}

	buildOneDataTable(dataTable, seasonsData, playerAccount, callback) {

		seasonsData.forEach(function(result, resultIdx) {

			// determine button value
			var btnValue = 0;
			if (playerAccount < 0) {
				btnValue = -Math.max(playerAccount, result.qvneaBooks.balance);
				btnValue = (btnValue > 0) ? 0 : btnValue;
			} else {
				// maximum is playerAccount (compte joueur) or balance
				btnValue = Math.min(playerAccount, -result.qvneaBooks.balance);
			}

			var dataTableRow = [];
			dataTableRow.push(result.leagueName);
			dataTableRow.push(result.seasonName);
			dataTableRow.push(result.qvneaBooks.inscription);
			dataTableRow.push(result.qvneaBooks.paiement);
			dataTableRow.push(result.qvneaBooks.bourse);
			dataTableRow.push(result.qvneaBooks.versement);
			dataTableRow.push(result.qvneaBooks.transfert);
			dataTableRow.push(result.qvneaBooks.balance);
			dataTableRow.push(btnValue);
			dataTableRow.push(result.leagueId);
			dataTableRow.push(result.seasonId);

			// Build table
			dataTable.push(dataTableRow.slice());
		});

		callback();
	}

	sortdataTable(dataTable, sortFieldIdx, sortOrder, playerId) {

		// Manage empty data
		if (dataTable.length !== 0) {

			var sortSign = 1;
			if (sortOrder === 'desc') { 
				sortSign = -1; 
			}

			// console.log('dataTable');
			// console.log(dataTable);

			dataTable.sort(function(a, b) {
				var valueA = a[sortFieldIdx];
				var valueB = b[sortFieldIdx];
				var compVal = 0;

				switch(typeof a[sortFieldIdx]) {
			    case "date":
						compVal = new Date(valueA) - new Date(valueB);
		        break;
			    case "string":
						compVal = valueA.localeCompare(valueB);
		        break;
			    case "number":
						compVal = valueA - valueB;
		        break;
			    default:
		        break;
				}

				if (compVal !== 0) {
					return (sortSign * compVal);
				} else {
					return a[0].localeCompare(b[0]);
				}
			});
		}

		this.setState({
			playerId: playerId,
			dataTable: dataTable,
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder,
		});
	}

 	render() {
		// console.log('QvneaBooksPlayerAccount: RENDER');
		// console.log(this.state);
		var sortClass = this.state.sortClass;

		return (
      <div>
      	<div className="row">
      	<div className="col-12">
					<h5>QVNEA - SOMMAIRE DES SAISONS</h5>
					<br/>

					{/* PLAYER SEARCH */}
		     	<div className="row">
			    <div className="col-md-4 col-sm-6 col-12">
						<h6>Joueur </h6>
						<AutoSuggestPlayer playerId={this.state.playerId} dataChange={this.handlePlayerChange}/>
					</div>
					</div>
					<br/>

		     	<div className="row">
	      	<div className="col-8 col-xl-6">
						<h6>Joueur: {this.state.player.fullnameB}</h6>
					</div>
					</div>
					<br/>

		     	<div className="row">
	      	<div className="col-8 col-xl-6">
						<h6>SOMMAIRE DU COMPTE</h6>
						<table className="table table-sm">
						<tbody>
							<tr>
								<td>QVNEA Compte du Joueur</td>
								<td>{this.state.seasonsTotal.playerAccount.toFixed(2) + ' $'}</td>
							</tr>
							<tr>
								<td>Solde Ligues</td>
								<td>{this.state.seasonsTotal.balance.toFixed(2) + ' $'}</td>
							</tr>
							<tr>
								<td><strong>Balance</strong></td>
								<td><strong>{this.state.seasonsTotal.playerBalance.toFixed(2) + ' $'}</strong></td>
							</tr>
						</tbody>
						</table>
					</div>
					</div>
					<br/>

					<div className="table-responsive">
					<table className="table table-hover table-sm">
					<thead>
						<tr>
							{cstTableHeaders.map(this.createTableHdrRow.bind(this, 1))}
						</tr>
					</thead>

					{this.createTotalRow(this.state.seasonsTotal)}
					{this.displayTable()}
					</table>
					</div>

      	</div>
      	</div>
      </div>
    );
  }

	createTableHdrRow(tableIdx, hdrItem, hdrIdx) {

		// ID Visible only in master mode
		var classNameStr = '';
		var onClickAction = function() {};

		var sortFieldIdx = 0;;
		var sortOrder = "asc";

		sortFieldIdx = this.state.sortFieldIdx;
		sortOrder = this.state.sortOrder;
		onClickAction = this.handleSortTable.bind(this);

		// Sort with arrows
		classNameStr = 'statelo-sorting';
		if(hdrIdx === sortFieldIdx) {
			if (sortOrder === "asc") {
				classNameStr += ' statelo-sorting_asc';
			} else {
				classNameStr += ' statelo-sorting_desc';
			}
		}

		var colWidth = "auto";
		if (hdrIdx >= 2) {
			colWidth = "80px";
			classNameStr += " text-right";
		}

		if ((hdrIdx === 2) || (hdrIdx === 7) || (hdrIdx === 8)) {
			classNameStr += " tdLeftBorder";
		}

		return (
			<th key={"colid." + hdrIdx}
				id={"colid." + hdrIdx} 
				className={classNameStr}
				onClick={onClickAction}
				width={colWidth}>
				{hdrItem}
			</th>
		);
	}

	displayTable() {
		if (this.state.dataTable.length === 0) {
			return (
				<tbody>
					<tr><td colSpan="99">Aucune saison</td></tr>
				</tbody>
			)
		} else {
			return (
				<tbody>
					{this.state.dataTable.map(this.createDataRow)}
				</tbody>
			)
		}
	}

	createTotalRow(playersTotal) {
		return (
			<tbody>
			<tr className="headBackground">
				<td>Total</td>
				<td></td>
				<td className="text-right tdLeftBorder">{playersTotal.inscription.toFixed(2) + ' $'}</td>
				<td className="text-right">{playersTotal.paiement.toFixed(2) + ' $'}</td>
				<td className="text-right">{playersTotal.bourse.toFixed(2) + ' $'}</td>
				<td className="text-right">{playersTotal.versement.toFixed(2) + ' $'}</td>
				<td className="text-right">{playersTotal.transfert.toFixed(2) + ' $'}</td>
				<td className="text-right tdLeftBorder">{playersTotal.balance.toFixed(2) + ' $'}</td>
				<td className="text-center tdLeftBorder" width="180px">Transferts Compte Joueur</td>
      </tr>
			</tbody>
		)
	}

  createDataRow(dataRow, dataRowIdx) {
  	// show first 9 columns only
		return (
			<tr key={'te.' + dataRowIdx}>
				{dataRow.slice(0, 9).map(this.createDataCell.bind(this, dataRowIdx))}
      </tr>
    );
  }

 	createDataCell(dataRowIdx, dataCell, dataCellIdx) {
 		var classNameStr = "";

 		if (dataCellIdx === 7) {
 			classNameStr = "font-weight-bold";
 		}
		if ((dataCellIdx === 2) || (dataCellIdx === 7) || (dataCellIdx === 8)) {
			classNameStr += " tdLeftBorder";
		}

		// Bouton: Ajustement avec Compte Joueur
		var accountAdjustBtnTxt = "";
		var extraClassName = "";
		var spanClassName = "";
		var showBtn = (dataCell !== 0);
		if (dataCellIdx === cstAccountTransferBtnIdx) {
			if (dataCell < 0) {
				accountAdjustBtnTxt = " Compte Joueur (" + (-dataCell).toFixed(2) + ' $' + ")";
				extraClassName = "btn-primary btn-qvnea-player-account-balance";
				spanClassName = "fa fa-arrow-right";
			} else {
				accountAdjustBtnTxt = " Compte Joueur (" + dataCell.toFixed(2) + ' $' + ")";
				extraClassName = "btn-qvnea btn-qvnea-player-account-balance";
				spanClassName = "fa fa-arrow-left";
			}
		}

		// all others
 		if ((dataCellIdx > 1) && (dataCellIdx < 8)) {
 			dataCell = dataCell.toFixed(2) + ' $';
 			classNameStr += " text-right";
 		}

		if (dataCellIdx !== cstAccountTransferBtnIdx) {
			return ( <td className={classNameStr} key={"tdcell." + dataCellIdx}> {dataCell} </td> );
		} else if (showBtn) {
			return (
				<td className={classNameStr + " text-center td-qvnea-btn-padding"} key={"tdcell." + dataCellIdx}>
					<button type="button" className={"btn btn-sm2 " + extraClassName}
						onClick={this.handleSetAccountBalanceClick.bind(this, dataRowIdx)}>
						<span className={spanClassName}>{accountAdjustBtnTxt}</span>
					</button>
				</td>
			)
		} else {
			return ( <td className={classNameStr} key={"tdcell." + dataCellIdx}></td> )
		}
	}

  handleSetAccountBalanceClick(dataRowIdx, e) {
  	var _this = this;

    // qvneaBooksObj.date = moment(qvneaBooksObj.date).utc().startOf('day').toISOString();
  	var playerId = this.state.player._id;
    var amount = this.state.dataTable[dataRowIdx][8];
    var leagueId = this.state.dataTable[dataRowIdx][9];
    var seasonId = this.state.dataTable[dataRowIdx][10];

		var txDirection = "fromPlayerAccount";
    if (amount < 0) {
    	txDirection = "toPlayerAccount";
    	amount = -amount;
    }

		var myDate = new Date();
		myDate.setUTCHours(12,0,0,0);
   
  	var operationObj = {
  		date: myDate,
  		user: this.props.profile.name,
  		txDirection: txDirection,
  		amount: amount,
  		leagueId: leagueId,
  		seasonId: seasonId,
  		playerId: playerId
  	};

		// Post operation
		Axios.post('/api/qvneaBooks/savePlayerAccountTransfer', {
			sourceType: 'playerAccount',
			operationObj: operationObj,
		})
		.then(function(response) {
    	_this.createDataTable(playerId, response.data);
		})
		.catch(function(error) {
			console.log('ERROR');
			console.log(error);
		});

  }

	handleSortTable(e) {
		var _this = this;
		var sortFieldIdx = parseInt(e.target.id.split(".")[1], 10);

		var dataTable = this.state.dataTable;
		var sortOrder = this.state.sortOrder;
		var prevSortFieldIdx = this.state.sortFieldIdx;

		// Toggle sort order
		if (prevSortFieldIdx === sortFieldIdx) {
			if (sortOrder === 'asc') {
				sortOrder = 'desc';
			} else {
				sortOrder = 'asc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[sortFieldIdx];
		}

		this.sortdataTable(dataTable, sortFieldIdx, sortOrder, _this.state.playerId);
	}

	handlePlayerChange(playerId) {
		if (playerId !== '0') {
			localStorage.setItem('filtPlayerId', playerId);
		}
    this.loadSeasonsBalance(playerId);
	}

}

export default QvneaBooksPlayerAccount;

